import React, { useState } from 'react';
import ImageCover from "../assetes/image11.jpg";
import Logo from "../assetes/Suite Logo.png";
import { FaUser, FaEnvelope, FaPhone, FaComment } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { sendContactUs } from '../redux/slices/ContactUs';

function ContactUs() {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [message, setMessage] = useState("");
    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault(); // منع إعادة تحميل الصفحة

        const contactData = {
            email,
            name,
            phoneNumber,
            message
        };

        dispatch(sendContactUs(contactData)); // إرسال البيانات إلى Redux
    };

    return (
        <div className="relative w-full min-h-screen bg-cover flex flex-col overflow-hidden" style={{ backgroundImage: `url(${ImageCover})` }}>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            
            {/* الهيدر */}
            <header className="w-full py-4 z-[10000]">
                <div className="container mx-auto flex justify-center">
                  <a href="/">
                    <img src={Logo} alt="logo" className="w-40 md:w-60" />
                    </a> 
                </div>
            </header>
     
            {/* المحتوى الرئيسي */}
            <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4 z-[10000]">
                <div className="text-white mb-8 md:mb-0 md:w-1/2">
                    <h1 className="font-bold text-3xl md:text-4xl mb-4">
                        <span className="text-[rgb(166,116,28)]">VIP Wellness</span> Suite in Wuppertal
                    </h1>
                    <p className="text-lg mb-4">
                        Wir laden Sie herzlich in unsere private VIP Wellness Suite in Wuppertal ein – ein exklusiver Rückzugsort für vollkommene Entspannung. Genießen Sie die traditionelle orientalische Badekultur in einem luxuriösen Ambiente, das speziell für Ihre Erholung und Ihr Wohlbefinden geschaffen wurde. Lassen Sie den Alltag hinter sich und erleben Sie eine Reise der Ruhe und Erneuerung.
                    </p>
                    <p className="text-lg mb-4">
                        Sie haben noch Fragen oder Wünsche? Unser Team hilft Ihnen gerne weiter, rufen Sie an unter:
                    </p>
                    <p className="text-lg">
                        Telefon: 0202 / 747 574 00 oder füllen Sie das nachfolgende Formular aus.
                    </p>
                </div>

                {/* النموذج */}
                <div className="bg-white px-6 py-8 rounded-lg shadow-lg w-full md:w-1/2 max-w-md">
                    <form className="flex flex-col gap-4">
                        <div className="relative">
                            <FaUser className="absolute left-3 top-3 text-gray-500" />
                            <input
                                type="text"
                                placeholder="Ihr Name*"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring focus:ring-blue-200 outline-none"
                            />
                        </div>
                        <div className="relative">
                            <FaEnvelope className="absolute left-3 top-3 text-gray-500" />
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Ihre E-Mail Adresse*"
                                className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring focus:ring-blue-200 outline-none"
                            />
                        </div>
                        <div className="relative">
                            <FaPhone className="absolute left-3 top-3 text-gray-500" />
                            <input
                                type="tel"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                placeholder="Ihre Telefonnummer*"
                                className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring focus:ring-blue-200 outline-none"
                            />
                        </div>
                        <div className="relative">
                            <FaComment className="absolute left-3 top-3 text-gray-500" />
                            <textarea
                                placeholder="Ihre Nachricht"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring focus:ring-blue-200 outline-none h-24 resize-none"
                            />
                        </div>
                        <button
                            onClick={handleSubmit}
                            className="bg-[rgb(166,116,28)] text-white py-2 rounded-[14px] hover:bg-[#777] transition w-full md:w-40"
                        >
                            Senden
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;